import { render, staticRenderFns } from "./InsuranceStats.vue?vue&type=template&id=71c9898f&scoped=true"
import script from "./InsuranceStats.vue?vue&type=script&lang=js"
export * from "./InsuranceStats.vue?vue&type=script&lang=js"
import style0 from "./InsuranceStats.vue?vue&type=style&index=0&id=71c9898f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c9898f",
  null
  
)

export default component.exports